"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHealthCheckDaysOfWeekValue = void 0;
const core_1 = require("../../../core");
const getEverydayList_1 = require("./getEverydayList");
const getDaysOfWeekList_1 = require("./getDaysOfWeekList");
const getListBy_1 = require("./getListBy");
const types_1 = require("../types");
const getHealthCheckDaysOfWeekValue = (healthCheckModelValue, isDailyScheduleEnabled, isWeeklyScheduleEnabled, dailyScheduleModelValue, weeklyScheduleModelValue) => {
    const fieldDayOfWeekValue = healthCheckModelValue.fieldDayOfWeekValue;
    if (fieldDayOfWeekValue === types_1.HEALTH_CHECK_EXTENDED_DAY_OF_WEEK.scheduledDay) {
        if (isDailyScheduleEnabled) {
            const dailykind = dailyScheduleModelValue.fields.kind;
            switch (dailykind) {
                case types_1.DAILY_SCHEDULE_KINDS.everyday:
                    return getEverydayList_1.getEverydayList();
                case types_1.DAILY_SCHEDULE_KINDS.weekDays:
                    return [
                        core_1.DAY_OF_WEEK.monday,
                        core_1.DAY_OF_WEEK.tuesday,
                        core_1.DAY_OF_WEEK.wednesday,
                        core_1.DAY_OF_WEEK.thursday,
                        core_1.DAY_OF_WEEK.friday,
                    ];
                case types_1.DAILY_SCHEDULE_KINDS.selectedDays:
                    return dailyScheduleModelValue.fields.days;
            }
        }
        if (!isDailyScheduleEnabled && isWeeklyScheduleEnabled) {
            return getListBy_1.getListBy(weeklyScheduleModelValue.rows.third.schedule, getDaysOfWeekList_1.getDaysOfWeekList());
        }
        return undefined;
    }
    return fieldDayOfWeekValue && [fieldDayOfWeekValue];
};
exports.getHealthCheckDaysOfWeekValue = getHealthCheckDaysOfWeekValue;
//# sourceMappingURL=getHealthCheckDaysOfWeekValue.js.map